import React from 'react'

import {
    CheckboxSlider,
    Form,
    HeadlineInfo
} from '@varta/digital-styleguide/build/src/components/02.molecules'

import { useFormData } from '../../../redux/data/hooks/useFormData'
import { useNavigation } from '../../../redux/navigation/hooks/useNavigation'
import { useSettings } from '../../../redux/settings/hooks/useSettings'

import {
    APPLICATION_CAMPING,
    WEIGHT,
    WEIGHT_LOW,
    WEIGHT_HIGH
} from '../../../data/strings'

import './_index.scss'

const CLASSNAME = 'varta-leisure-camping-wizard'
const cnRow = `${ CLASSNAME }__row`

/**
 * 
 * @returns 
 */
export default function Weight ({ i18n }) {

    const { formData, addInputFormData } = useFormData(APPLICATION_CAMPING)
    const { setConfirmButton } = useNavigation(APPLICATION_CAMPING)
    const { mobile } = useSettings()

    /**
     * 
     * @param {event} e 
     */
    function handleChange (e) {
        addInputFormData(WEIGHT, e.target.value)
        setConfirmButton(true)
    }

    return (
        <>
            <HeadlineInfo level={2}>
                { i18n[WEIGHT].title }
            </HeadlineInfo>
            <Form
                onChange={ handleChange }
            >
                <div className={ cnRow }>
                    <CheckboxSlider
                        iconId='balance-scale'
                        options={ [
                            { label: i18n[WEIGHT].weightLow, value: WEIGHT_LOW },
                            { label: i18n[WEIGHT].weightHigh, value: WEIGHT_HIGH },
                        ] }
                        selected={ formData[WEIGHT] }
                        type={ mobile ? 'vertical' : 'horizontal' }
                    />
                </div>
            </Form>
        </>
    )
}